export const duplicateCompaniesPath = state => state.paths.companies.duplicates;
export const duplicatePeoplePath = state => state.paths.people.duplicates;
export const emptyStateHelpPath = state => state.paths.emptyStateHelp;
